import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import BookingRequestsManagement from "./booking-requests-management.component";
import { a11yProps } from "../../features/TabPanel/TabPanel.partial";
import { TabPanel } from "../../features/TabPanel/TabPanel.component";
import { CustomColoredTabs } from "../CustomColoredTabs/CustomColoredTabs.component";
import { CustomColoredTab } from "../CustomColoredTabs/CustomColoredTab.component";

export const BookingRequests = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [valueState, setValueState] = useState(0);

  const handleChange = (event: React.SyntheticEvent<{}>, newValue: number) =>
    setValueState(newValue);

  return (
    <Box sx={{ "& > *": { margin: theme.spacing(1) } }} data-testid="booking-requests-tabs-parent">
      <CustomColoredTabs value={valueState} onChange={handleChange}>
        <CustomColoredTab
          index={0}
          // theme={theme}
          data-testid={"tab1"}
          label={t("Manage Bookings")}
          {...a11yProps(0)}
        />
        {/* <CustomColoredTab index={0} theme={theme} data-testid={"tab2"} label={t("Archive")} {...a11yProps(1)} /> */}
      </CustomColoredTabs>
      <TabPanel value={valueState} index={0}>
        <BookingRequestsManagement mode={"active"} />
      </TabPanel>
      {/* not yet implemented, because BE returns Err for Archive */}
      {/* <TabPanel value={valueState} index={1}>
        <BookingRequestsManagement mode={"archive"} />
      </TabPanel> */}
    </Box>
  );
};
